export const debugMode = false;
export const supported_resolutions = ['1', '5', '15'];
export const supports_search = false;
export const supports_group_request = false;
export const supports_marks = true;
export const supports_timescale_marks = true;
export const supports_time = true;
export const has_intraday = true;
export const has_daily = true;
export const has_weekly_and_monthly = true;
export const intraday_multipliers = ['1', '5'];
export const daily_multipliers = ['1'];
export const weekly_multipliers = ['1'];
export const monthly_multipliers = ['1'];

export const exchanges = [];
export const symbols_types = [];
export const availableSymbols = [];

export const sessions = {
    "test": "1830-1830:23456",
    "#": "1330-2100:23456"
}

export const getInstrument = {
    "sharemarkett":"https://getinstrumentdetails-dqjetxu7eq-ey.a.run.app",

}

export const feedServer = {
    "sharemarkett": "https://feed.sharemarkett.com/broadcast",
    
}

export const historicalApiHost = {
    "sharemarkett":"https://historicaldata.sharemarkett.com",
}
